import Translator from '../../../Shared/translator';
import v1_v2 from './v1_v2';
import v2_v3 from './v2_v3';

const translator: Translator = {
  ['v1_v2']: v1_v2,
  ['v2_v3']: v2_v3
};

export default translator;
